require('./dropdownFunds.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const FundItem = require('./fundItem');

const FundItemSelected = props => {
    const {value} = props;
    const account = value
    const id = `${account.id}_Selected`;

    return (
        <div id={id} className="Select-value dropdown-funds__account">
            <div className="Select-value-label">
                <div className="dropdown-funds__account-description dropdown-funds__account-description--vertically-centered">
                    <FundItem account={account}/>
                </div>
            </div>
        </div>
    );
};

FundItemSelected.propTypes = {
    value: PropTypes.object
};

module.exports = FundItemSelected;